import ContextMiddleware from "./middleware/ContextMiddleware";

const Applications = () => import('../modules/Applications/views/Applications');
const Login = () => import('../views/login/Login');
const LoginNest = () => import('../views/login/LoginNest.js');
const SetNewPassword = () => import('../views/SetNewPassword');
const Logout = () => import('../views/logout/Logout.js');
const LogoutNest = () => import('../views/logout/LogoutNest.js');
const Profile = () => import('../views/Profile');
const PersonalData = () => import('../views/profile/PersonalData');
const EmailBoxes = () => import('../modules/Email/Accounts/views/EmailBoxes');
const Templates = () => import('../modules/Email/Templates/views/Templates');
const CredentialsManager = () => import('../modules/Credentials/views/CredentialsManager');
const FacebookConnect = () => import('../modules/Integration/Facebook/views/FacebookConnect');

import LoggedMiddleware from './middleware/LoggedMiddleware';
import NotLoggedMiddleware from './middleware/NotLoggedMiddleware';
import RedirectToContextMiddleware from "./middleware/RedirectToContextMiddleware";
import {navigateToLoginPage, navigateToLogoutPage} from "@/routes/middleware/AuthMethodsResolverMiddleware";

export default [
    // Fasada pod logowanie
    { path: '/login', name: 'Login', meta: {middleware: [ContextMiddleware, navigateToLoginPage]}},
    { path: '/logout', name: 'Logout', meta: {middleware: [ContextMiddleware, navigateToLogoutPage]}},

    // Default login
    { path: '/auth/login', name: 'LoginDefault', component: Login, meta: {middleware: [ContextMiddleware, RedirectToContextMiddleware, NotLoggedMiddleware]}},
    { path: '/auth/logout', name: 'LogoutDefault', component: Logout, meta: {middleware: [ContextMiddleware]}},

    // Nest
    { path: '/auth/nest/login', name: 'LoginNest', component: LoginNest, meta: {middleware: [ContextMiddleware, RedirectToContextMiddleware, NotLoggedMiddleware]}},
    { path: '/auth/nest/logout', name: 'LogoutNest', component: LogoutNest},
    
    { path: '/set-new-password', name: 'SetNewPassword', component: SetNewPassword, meta: {middleware: [NotLoggedMiddleware]}},

    // Profil użytkownika
    {
        path: '/profile',
        component: Profile,
        meta: {middleware: [LoggedMiddleware]},
        children: [
            {
                path: '',
                name: 'Applications',
                component: Applications,
                meta: {middleware: [LoggedMiddleware]},
            },
            {
                path: 'personal-data',
                name: 'PersonalData',
                component: PersonalData,
                meta: {middleware: [LoggedMiddleware]},
            },
            {
                path: 'email-boxes',
                name: 'EmailBoxes',
                component: EmailBoxes,
                meta: {middleware: [LoggedMiddleware]},
            },
            {
                path: 'templates',
                name: 'Templates',
                component: Templates,
                meta: {middleware: [LoggedMiddleware]},
            },
            {
                path: 'credentials',
                name: 'CredentialsManager',
                component: CredentialsManager,
                meta: {middleware: [LoggedMiddleware]},
            },
            {
                path: 'integration/facebook/connect',
                name: 'FacebookConnect',
                component: FacebookConnect,
                meta: {middleware: [LoggedMiddleware]},
            }
        ]
    },

    { path: '/', name: 'Dashboard', redirect: {name: 'Applications'}},

    // Niepasujące routingi są przekierowywane do strony głównej
    { path: '*', redirect: {name: 'Applications'}}

];
